import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import QuestionGroupScreen from '../../../components/screens/question_group';
import { makeGetQuestionGroupScreenProps } from '../../../selectors/player';

import {
  runShape,
  questionShape,
  answerShape,
  exerciseShape,
  questionGroupShape
} from '../../../shapes/entities';
import { modeType } from '../../../shapes/types';

import { answer } from '../../../actions/player';

export class QuestionGroupScreenWrapper extends Component {
  constructor(props) {
    super(props);

    this.updateAnswer = this.updateAnswer.bind(this);
  }

  updateAnswer(choices) {
    const { run, exercise } = this.props;

    this.props.answer(run, exercise, choices);
  }

  render() {
    const {
      run,
      mode,
      exercise,
      source,
      showHighlighter,
      showInstantSolution,
      questionsWithAnswers
    } = this.props;

    const { answered: selected } = exercise.attributes;
    const {
      always_show_solution: alwaysShowSolution,
      auto_expand_solution: autoExpandSolution
    } = run.attributes;

    return (
      <QuestionGroupScreen
        mode={mode}
        source={source}
        selected={selected}
        questionsWithAnswers={questionsWithAnswers}
        highlightsId={exercise.id}
        showHighlighter={showHighlighter}
        alwaysShowSolution={alwaysShowSolution}
        autoExpandSolution={autoExpandSolution}
        showInstantSolution={showInstantSolution}
        onUpdateAnswer={this.updateAnswer}
      />
    );
  }
}

QuestionGroupScreenWrapper.propTypes = {
  run: runShape.isRequired, // eslint-disable-line react/no-typos
  exercise: exerciseShape.isRequired, // eslint-disable-line react/no-typos
  source: questionGroupShape.isRequired, // eslint-disable-line react/no-typos
  answer: PropTypes.func.isRequired,
  mode: modeType.isRequired, // eslint-disable-line react/no-typos
  showHighlighter: PropTypes.bool.isRequired,
  showInstantSolution: PropTypes.bool.isRequired,
  questionsWithAnswers: PropTypes.arrayOf(
    PropTypes.shape({
      question: questionShape,
      answers: PropTypes.arrayOf(answerShape)
    })
  ).isRequired
};

const mapStateToProps = makeGetQuestionGroupScreenProps;

const mapDispatchToProps = {
  answer
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionGroupScreenWrapper);
